<script setup lang="ts">
  interface Props {
    startDateTime: string;
  }
  const props = defineProps<Props>();

  const elapsedTime = ref<string>();

  let timerId: any | null = null;

  const setElapsedTime = () => {
    if (props.startDateTime) {
      elapsedTime.value = GetElapsedTimeText(props.startDateTime);
    }
  };

  onMounted(() => {
    // 1秒ごとに時間を設定し直す
    setElapsedTime();
    timerId = setInterval(() => {
      setElapsedTime();
    }, 1000);
  });

  onUnmounted(() => {
    if (timerId) {
      clearInterval(timerId);
    }
  });
</script>

<template>
  <v-sheet class="px-3 py-1 rounded-xl timer-text timer-bg" variant="elevated" size="x-small">
    <img class="mr-1 ml-1" :width="9" :height="10" src="@/assets/images/icon/liveIcon.svg" alt="livetimer" />
    <span class="mr-2">LIVE</span>
    <span>{{ elapsedTime }}</span>
  </v-sheet>
</template>

<style lang="scss" scoped>
  .timer-bg {
    background: rgba(var(--v-theme-main-02), 0.5);
  }

  .timer-text {
    font-size: 12px;
    font-weight: 700;
    line-height: 16.34px; // 数字がズレるので個別に指定
  }
</style>
